/* globals translation */

import {
  accordion, closestByClassName, scrollTo, triggerEvent,
} from './functions';

const quizAddLoading = () => {
  const currentActiveContainer = document.querySelector('.module-skin-care-quiz .step.active');
  if (currentActiveContainer !== null) {
    currentActiveContainer.classList.add('loading');
    scrollTo(currentActiveContainer.offsetTop - 270, 500);
  }
};


const quizRemoveLoading = () => {
  const currentActiveContainer = document.querySelector('.module-skin-care-quiz .step.loading');
  if (currentActiveContainer !== null) {
    currentActiveContainer.classList.remove('loading');
  }
};


const quizGoToStep = (stepID) => {
  const currentActiveContainer = document.querySelector('.module-skin-care-quiz .step.active');
  const prevStepID = currentActiveContainer.dataset.step;
  if (currentActiveContainer) {
    currentActiveContainer.classList.remove('active');

    const goToStepContainer = document.querySelector(`#step-${stepID}`);
    goToStepContainer.classList.add('active');
  }

  if (stepID < prevStepID) {
    document.getElementById(`quiz-pagination-step-${prevStepID}`).classList.remove('active');
  }

  if (stepID > 1) {
    document.getElementById(`quiz-pagination-step-${stepID}`).classList.toggle('active');
  }

  // If products have been added before
  document.body.classList.remove('quiz-products-added');

  quizRemoveLoading();
};


const addToCartButton = (event) => {
  const button = event.target;
  const selectedProducts = Array.from(document.querySelectorAll('.term-group:not(.hide) input[name="add_to_cart"]:checked'));
  const countSelectedProducts = selectedProducts.length;

  if (countSelectedProducts === 0) {
    button.disabled = true;
  } else {
    button.disabled = false;
  }

  button.innerText = `${translation.quiz_add} (${countSelectedProducts}) ${translation.quiz_in_the_cart}`;
};

const quizAddProductsToCartButton = document.getElementById('add-products-to-cart');
if (quizAddProductsToCartButton) {
  quizAddProductsToCartButton.addEventListener('updated', addToCartButton);
}


const addStepNumbers = () => {
  const termGroups = Array.from(document.querySelectorAll('.quiz-result-here .term-group:not(.hide)'));
  let step = 1;

  termGroups.forEach((group) => {
    const title = group.querySelector('.term-title');
    const currentText = title.dataset.title;

    // Change the title text to include the step number
    title.innerText = `${translation.step} ${step} / ${currentText}`;

    // Increase the step number
    step += 1;
  });
};
document.body.addEventListener('quiz-step-number-update', addStepNumbers);


// Add a max option check of each of the options in the scin care quiz
const quizCheckboxes = Array.from(document.querySelectorAll('input.skin-care-quiz-checkbox'));
if (quizCheckboxes) {
  quizCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      const { maxOptions } = checkbox.dataset;

      // Only trigger when checkbox get activated
      if (maxOptions && checkbox.checked) {
        const chosen = Array.from(document.querySelectorAll(`input[name="${checkbox.name}"]:checked`));

        if (chosen.length > Number(maxOptions)) {
          // eslint-disable-next-line no-param-reassign
          checkbox.checked = false;

          alert(`${translation.you_can_choose_max} ${maxOptions} ${translation.options_on_this_step}`);
        }
      }
    });
  });
}


const addScrollCheckToQuizToggle = () => {
  const container = document.querySelector('ul.simple-or-advanced');
  const distance = container.offsetTop + 80;

  window.addEventListener('scroll', () => {
    const fromTop = window.pageYOffset;
    const bodyEl = document.body;

    if (fromTop > distance) {
      bodyEl.classList.add('sticky-simple-or-advanced');
    } else {
      bodyEl.classList.remove('sticky-simple-or-advanced');
    }
  });
};


const skinCareQuiz = () => {
  jQuery('form.skin-care-quiz').submit((event) => {
    event.preventDefault();

    if (Array.from(document.querySelectorAll('input[name="pa_egenskap"]:checked')).length < 1) {
      alert(translation.choose_at_least_one);
      return;
    }

    quizAddLoading();

    triggerEvent(document.getElementById('add-products-to-cart'), 'updated');

    const skinTypes = [];
    const features = [];

    Array.from(document.querySelectorAll('input[name="pa_skin"]:checked')).forEach((feature) => {
      skinTypes.push(feature.value);
    });

    Array.from(document.querySelectorAll('input[name="pa_egenskap"]:checked')).forEach((feature) => {
      features.push(feature.value);
    });

    // The ajax request payload
    const payload = {
      action: 'mcb_scq_fetch_products',
      skin_types: skinTypes,
      features,
    };

    const skinCareResult = document.querySelector('.skin-care-result .quiz-result-here');

    // Clear current result
    if (skinCareResult !== null) {
      skinCareResult.innerHTML = '';

      jQuery.post(translation.ajaxurl, payload, (response) => {
        skinCareResult.innerHTML = response;
        const completeQuizButton = document.querySelector('.module-skin-care-quiz .step .complete-quiz');
        const simpleTermGroups = Array.from(document.querySelectorAll('.term-group:not(.advanced)'));
        const simpleTermGroupsOnly = Array.from(document.querySelectorAll('.term-group.only-simple'));
        const advancedTermGroups = Array.from(document.querySelectorAll('.term-group.advanced'));

        const { goToStep } = completeQuizButton.dataset;

        quizGoToStep(goToStep);
        accordion();
        triggerEvent(document.getElementById('add-products-to-cart'), 'updated');
        triggerEvent(document.body, 'quiz-step-number-update');

        const simpleDifficultyButtonSpan = document.querySelector('.simple-or-advanced a.simple > span');
        simpleDifficultyButtonSpan.innerText = `${simpleTermGroups.length} ${translation.steps}`;

        const advancedDifficultyButtonSpan = document.querySelector('.simple-or-advanced a.advanced > span');
        advancedDifficultyButtonSpan.innerText = `${simpleTermGroups.length + advancedTermGroups.length - simpleTermGroupsOnly.length} ${translation.steps}`;

        Array.from(document.querySelectorAll('ul.simple-or-advanced > li > a')).forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault();

            // Exit if clicking on the current button
            if (button.classList.contains('active-difficulty')) {
              return;
            }

            const { is } = button.dataset;
            const activeDifficulty = document.querySelector('.active-difficulty');

            // Remove current active class from menu
            activeDifficulty.classList.remove('active-difficulty');

            // Add the active class to the new difficulty button
            button.classList.add('active-difficulty');

            if (is === 'simple') {
              simpleTermGroupsOnly.forEach((group) => {
                group.classList.remove('hide');
              });

              advancedTermGroups.forEach((group) => {
                group.classList.add('hide');
              });
            } else if (is === 'advanced') {
              simpleTermGroupsOnly.forEach((group) => {
                group.classList.add('hide');
              });

              advancedTermGroups.forEach((group) => {
                group.classList.remove('hide');
              });
            }

            triggerEvent(document.getElementById('add-products-to-cart'), 'updated');
            triggerEvent(document.body, 'quiz-step-number-update');
          });
        });

        Array.from(document.querySelectorAll('a.toggle-more-about-skin-type')).forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            button.parentNode.querySelector('.about-skin-type').classList.toggle('show');
          });
        });

        Array.from(document.querySelectorAll('input[name="add_to_cart"]')).forEach((checkbox) => {
          checkbox.addEventListener('change', (e) => {
            e.preventDefault();
            triggerEvent(document.getElementById('add-products-to-cart'), 'updated');
          });
        });

        addScrollCheckToQuizToggle();
      });
    }
  });

  Array.from(document.querySelectorAll('.module-skin-care-quiz .step .go-to-step')).forEach((goToStepButton) => {
    goToStepButton.addEventListener('click', (event) => {
      event.preventDefault();
      const { goToStep } = goToStepButton.dataset;

      if (goToStep === '2') {
        if (Array.from(document.querySelectorAll('input[name="pa_skin"]:checked')).length < 1) {
          alert(translation.choose_at_least_one);
          return;
        }
      }

      quizAddLoading();
      setTimeout(() => {
        quizGoToStep(goToStep);
      }, 1000);
    });
  });


  jQuery('form.skin-care-result').submit((event) => {
    event.preventDefault();

    const productIds = [];

    Array.from(document.querySelectorAll('.term-group:not(.hide) input[name="add_to_cart"]:checked')).forEach((product) => {
      productIds.push(product.value);
    });

    if (productIds.length === 0) {
      alert(translation.no_products_selected);
      return;
    }

    quizAddLoading();

    const skinCareResult = document.querySelector('.skin-care-result .quiz-result-here');

    const payload = {
      action: 'mcb_scq_add_products_to_cart',
      product_ids: productIds,
    };

    // Post the add to cart request
    jQuery.post(translation.ajaxurl, payload, (response) => {
      triggerEvent(document.body, 'wc_fragment_refresh');

      setTimeout(() => {
        document.body.classList.add('quiz-products-added');
        skinCareResult.innerHTML = response;
        quizRemoveLoading();
      }, 2000);
    });
  });
};

skinCareQuiz();


jQuery(document).on('click', '.flip-the-card', (event) => {
  event.preventDefault();
  const card = closestByClassName(event.currentTarget, 'card');
  const front = card.querySelector('.front');
  const back = card.querySelector('.back');
  card.classList.toggle('flipped');

  if (card.classList.contains('flipped')) {
    setTimeout(() => {
      front.style.display = 'none';
      back.style.display = 'block';
    }, 300);
  } else if (!card.classList.contains('flipped')) {
    setTimeout(() => {
      back.style.display = 'none';
      front.style.display = 'block';
    }, 300);
  }
});
